
//首页信息
const index = {

    // 用户数据
    userData:[
        {
            name:'',
            count:'10',
            unit:'M+',
            type:['注册玩家','註冊玩家','Number of players'],
            imgURL:'',
            bgColor:'#58bd95'
        },
        {
            name:'',
            count:'100',
            unit:'K+',
            type:['活跃玩家','活躍玩家','Active user'],
            imgURL:'',
            bgColor:'#3b3b63'
        },
        {
            name:'',
            count:'>60',
            unit:'%',
            type:['次日留存','次日留存','Next day retention'],
            imgURL:'',
            bgColor:'#5e94f1'
        },
        {
            name:'',
            count:'90',
            unit:'Days+',
            type:['平均留存日数','平均留存日數','Averaging days'],
            imgURL:'',
            bgColor:'#ddb65f'
        },
        {
            name:'',
            count:'140k',
            unit:'Hours+',
            type:['每日游戏时间','每日遊玩時間','One day playtime'],
            imgURL:'',
            bgColor:'#ed6172'
        },
        {
            name:'',
            count:'5',
            unit:'M+',
            type:['广告日显示量','廣告日顯示量','One day advertising display'],
            imgURL:'',
            bgColor:'#5a599a'
        },
    ],
}
// 游戏信息配置
const games = {
    //遊戲鍵  => 鋤大D 大亨
    btthk:{
        gameKey:'btthk',
        name:['锄大D 大亨','鋤大D 大亨','鋤大D 大亨'],
        subTitle:['最刺激的策略棋牌游戏','最刺激的策略棋牌遊戲','最刺激的策略棋牌遊戲'],
        info:[
            '【正宗的国际玩法】牌局变幻莫测，每一轮出牌都要精心计算，谨慎出牌。这样节奏紧凑的比赛中，每一把都是心与心之间的较量，人与人之间的对抗！<br/>【全球统一的赛事】多场顶级的全球对决赛事，每个阶段晋级都要踏在无数全球高手的失败上前进，每次的决胜瞬间都是精彩绝伦，此生不忘的记忆！<br/>【独具一格的设计】极緻易上手的设计，无门槛进行游戏。并采用经典Q版风格，增强角色模型，大量特效匹配，多样化皮肤选择，满足极緻视觉追求！<br/>【丰富的活动奖励】大量的活动和福利，每日精选不同的奖励和随机buff，同时提供多种角色形象。坚持多样化、个性化的方案，纸爲畅快进行游戏！<br/>【先进的网络服务】全球顶级的服务器，登帐号六秒进游戏，匹配对手实时进行。网络无忧虑，快乐玩游戏' ,   
            '【正宗的國際玩法】牌局變幻莫測，每一輪出牌都要精心計算，謹慎出牌。這樣節奏緊湊的比賽中，每一把都是心與心之間的較量，人與人之間的對抗！<br/>【全球統一的賽事】多場頂級的全球對決賽事，每個階段晉級都要踏在無數全球高手的失敗上前進，每次的決勝瞬間都是精彩絕倫，此生不忘的記憶！<br/>【獨具一格的設計】極緻易上手的設計，無門檻進行遊戲。並采用經典Q版風格，增強角色模型，大量特效匹配，多樣化皮膚選擇，滿足極緻視覺追求！<br/>【豐富的活動獎勵】大量的活動和福利，每日精選不同的獎勵和隨機buff，同時提供多種角色形象。堅持多樣化、個性化的方案，衹爲暢快進行遊戲！<br/>【先進的網絡服務】全球頂級的服務器，登帳號六秒進遊戲，匹配對手實時進行。網絡無憂慮，快樂玩遊戲',
            '【正宗的國際玩法】牌局變幻莫測，每一輪出牌都要精心計算，謹慎出牌。這樣節奏緊湊的比賽中，每一把都是心與心之間的較量，人與人之間的對抗！<br/>【全球統一的賽事】多場頂級的全球對決賽事，每個階段晉級都要踏在無數全球高手的失敗上前進，每次的決勝瞬間都是精彩絕倫，此生不忘的記憶！<br/>【獨具一格的設計】極緻易上手的設計，無門檻進行遊戲。並采用經典Q版風格，增強角色模型，大量特效匹配，多樣化皮膚選擇，滿足極緻視覺追求！<br/>【豐富的活動獎勵】大量的活動和福利，每日精選不同的獎勵和隨機buff，同時提供多種角色形象。堅持多樣化、個性化的方案，衹爲暢快進行遊戲！<br/>【先進的網絡服務】全球頂級的服務器，登帳號六秒進遊戲，匹配對手實時進行。網絡無憂慮，快樂玩遊戲'
            ],
        appleURL:'https://itunes.apple.com/us/app/%E9%8B%A4%E5%A4%A7d%E5%A4%A7%E4%BA%A8-%E6%9C%80%E5%88%BA%E6%BF%80%E7%9A%84%E7%AD%96%E7%95%A5%E6%A3%8B%E7%89%8C%E9%81%8A%E6%88%B2/id1295634408?mt=8',
        googleURL:'https://play.google.com/store/apps/details?id=com.gameflask.btthk',
        downloads:'50000+',
        imgURL:'../../static/img/games/btthk_icon.jpg'
    },
    fmj16:{
        gameKey:'fmj16',
        name:['疯麻将16张','瘋麻將16張','瘋麻將16張'],
        subTitle:['100%台湾研发，台湾本土製造','100%台灣研發，台灣本土製造','100%台灣研發，台灣本土製造'],
        info:[
            ' 保证免费、超省荷包<br/> 离线照玩、不须上网<br/> 画质清晰、解析度高<br/> 更新频繁、耐玩性高' ,   
            ' 保證免費、超省荷包<br/> 離線照玩、不須上網<br/> 畫質清晰、解析度高<br/> 更新頻繁、耐玩性高' ,   
            ' 保證免費、超省荷包<br/> 離線照玩、不須上網<br/> 畫質清晰、解析度高<br/> 更新頻繁、耐玩性高' ,
            ],
        appleURL:'https://itunes.apple.com/us/app/%E7%98%8B%E9%BA%BB%E5%B0%8716%E5%BC%B5/id1252568150?mt=8',
        googleURL:'https://play.google.com/store/apps/details?id=com.funimax.funmahjong16',
        downloads:'50000+',
        imgURL:'../../static/img/games/fmj16_icon.jpg'
    },
    fbt:{
        gameKey:'fbt',
        name:['疯锄大Ｄ','瘋鋤大Ｄ','瘋鋤大Ｄ'],
        subTitle:['免注册立即玩，没网路也能玩','免註冊立即玩，沒網路也能玩','免註冊立即玩，沒網路也能玩'],
        info:[
            ' 锄大D又名大老二、锄大弟，採用正式国际规则，为世界多数国家所流行，尤以港澳、星马、欧美地区最为盛行。有别于台式玩法，採用国际规则的玩法让牌局更变化莫测，打牌过程中尽显刺激和心机，并且更著重于牌技面的呈现。让你无时无刻练牌技，打造锄大D神手之路!' ,   
            ' 鋤大D又名大老二、鋤大弟，採用正式國際規則，為世界多數國家所流行，尤以港澳、星馬、歐美地區最為盛行。有別於台式玩法，採用國際規則的玩法讓牌局更變化莫測，打牌過程中盡顯刺激和心機，並且更著重於牌技面的呈現。讓你無時無刻練牌技，打造鋤大D神手之路!' ,   
            ' 鋤大D又名大老二、鋤大弟，採用正式國際規則，為世界多數國家所流行，尤以港澳、星馬、歐美地區最為盛行。有別於台式玩法，採用國際規則的玩法讓牌局更變化莫測，打牌過程中盡顯刺激和心機，並且更著重於牌技面的呈現。讓你無時無刻練牌技，打造鋤大D神手之路!' ,
            ],
        appleURL:'https://itunes.apple.com/us/app/%E7%98%8B%E9%8B%A4%E5%A4%A7d/id1247782302?mt=8',
        googleURL:'https://play.google.com/store/apps/details?id=com.luckystargame.funbigtwo',
        downloads:'50000+',
        imgURL:'../../static/img/games/fbt_icon.jpg'
    },
    fsh:{
        gameKey:'fsh',
        name:['疯梭哈','瘋梭哈','瘋梭哈'],
        subTitle:['台、港、澳的经典热门扑克牌类游戏「梭哈」完美重现!','台、港、澳的經典熱門撲克牌類遊戲「梭哈」完美重現!','台、港、澳的經典熱門撲克牌類遊戲「梭哈」完美重現!'],
        info:[
            ' 优质的画面风格，绝对满足您挑剔的需求<br/>丰富的动态表现，让玩游戏变得更有趣，游戏画面不再死板<br/>快速上桌免等待，随时随地都能开启牌局，填满您的无聊时间<br/>清楚便捷的操作，一隻手就能游玩，轻鬆学习起来没烦恼<br/>面对各地的高手，共同挑战排行榜上的各式成绩，朝向第一名而努力<br/>详细的游戏分区，循序渐进的累积自己的实力<br/>不须网路与注册，简单下载轻鬆玩，没有麻烦的注册流程 <br/>成就与每日任务，疯狂好礼天天送，金币天天拿不完<br/>系统丰富花样多，丰富的头像、称号与金币等级，让您体验永远高人一等的爽度',   
            ' 優質的畫面風格，絕對滿足您挑剔的需求<br/>豐富的動態表現，讓玩遊戲變得更有趣，遊戲畫面不再死板<br/>快速上桌免等待，隨時隨地都能開啟牌局，填滿您的無聊時間<br/>清楚便捷的操作，一隻手就能遊玩，輕鬆學習起來沒煩惱<br/>面對各地的高手，共同挑戰排行榜上的各式成績，朝向第一名而努力<br/>詳細的遊戲分區，循序漸進的累積自己的實力<br/>不須網路與註冊，簡單下載輕鬆玩，沒有麻煩的註冊流程 <br/>成就與每日任務，瘋狂好禮天天送，金幣天天拿不完<br/>系統豐富花樣多，豐富的頭像、稱號與金幣等級，讓您體驗永遠高人一等的爽度' ,   
            ' 優質的畫面風格，絕對滿足您挑剔的需求<br/>豐富的動態表現，讓玩遊戲變得更有趣，遊戲畫面不再死板<br/>快速上桌免等待，隨時隨地都能開啟牌局，填滿您的無聊時間<br/>清楚便捷的操作，一隻手就能遊玩，輕鬆學習起來沒煩惱<br/>面對各地的高手，共同挑戰排行榜上的各式成績，朝向第一名而努力<br/>詳細的遊戲分區，循序漸進的累積自己的實力<br/>不須網路與註冊，簡單下載輕鬆玩，沒有麻煩的註冊流程 <br/>成就與每日任務，瘋狂好禮天天送，金幣天天拿不完<br/>系統豐富花樣多，豐富的頭像、稱號與金幣等級，讓您體驗永遠高人一等的爽度' ,
            ],
        appleURL:'https://itunes.apple.com/us/app/%E7%98%8B%E6%A2%AD%E5%93%88/id1238318956?mt=8',
        googleURL:'https://play.google.com/store/apps/details?id=com.luckystargame.funshowhand',
        downloads:'500k+',
        imgURL:'../../static/img/games/fsh_icon.jpg'
    },
    fbts:{
        gameKey:'fbts',
        name:['疯大老二','瘋大老二','瘋大老二'],
        subTitle:['台灣人自製的撲克遊戲《瘋大老二》，MIT品質有保證','台灣人自製的撲克遊戲《瘋大老二》，MIT品質有保證','台灣人自製的撲克遊戲《瘋大老二》，MIT品質有保證'],
        info:[
            '♠【华丽不夜城画风】仿如置身Las Vegas不夜城!<br/>♥【流畅爽快的节奏】打牌不顿挫，一路顺到底!<br/>♦【霸气的大牌特效】一出手就有王者风范!<br/>♣【智慧刁牌最贴心】把把出牌都精准到位!<br/>♠【免注册免等咖】等公车、等捷运随时都能”顺”一下!<br/>♥【没网路也爽爽打】纪录、战绩精准保留不漏失!<br/>♦【系统丰富多元】称号、成就、任务系统无一不缺，多功能的新体验。<br/>♣【胜局加码新玩法】独创新玩法，心脏够强，胆子够大者，等你来挑战。',   
            '♠【華麗不夜城畫風】仿如置身Las Vegas不夜城!<br/>♥【流暢爽快的節奏】打牌不頓挫，一路順到底!<br/>♦【霸氣的大牌特效】一出手就有王者風範!<br/>♣【智慧刁牌最貼心】把把出牌都精準到位!<br/>♠【免註冊免等咖】等公車、等捷運隨時都能”順”一下!<br/>♥【沒網路也爽爽打】紀錄、戰績精準保留不漏失!<br/>♦【系統豐富多元】稱號、成就、任務系統無一不缺，多功能的新體驗。<br/>♣【勝局加碼新玩法】獨創新玩法，心臟夠強，膽子夠大者，等你來挑戰。' ,   
            '♠【華麗不夜城畫風】仿如置身Las Vegas不夜城!<br/>♥【流暢爽快的節奏】打牌不頓挫，一路順到底!<br/>♦【霸氣的大牌特效】一出手就有王者風範!<br/>♣【智慧刁牌最貼心】把把出牌都精準到位!<br/>♠【免註冊免等咖】等公車、等捷運隨時都能”順”一下!<br/>♥【沒網路也爽爽打】紀錄、戰績精準保留不漏失!<br/>♦【系統豐富多元】稱號、成就、任務系統無一不缺，多功能的新體驗。<br/>♣【勝局加碼新玩法】獨創新玩法，心臟夠強，膽子夠大者，等你來挑戰。' ,
            ],
        appleURL:'https://itunes.apple.com/us/app/fun-big2-special/id1251326780?mt=8',
        googleURL:'https://play.google.com/store/apps/details?id=com.luckystargame.funbig2_tw',
        downloads:'1M+',
        imgURL:'../../static/img/games/fbts_icon.jpg'
    },
    bjm:{
        gameKey:'bjm',
        name:['21点狂人','21點狂人','21點狂人'],
        subTitle:['打造轻博弈游戏新经典','打造輕博弈遊戲新經典','打造輕博弈遊戲新經典'],
        info:[
            ' 《21点狂人》 以休閒娱乐为主体，并用简单的介面、独特玩法赔率、多人同场竞赛等特点，结合21点简单快节奏的特性，打造出以休閒娱乐型态为主的轻博弈类游戏。相较于市面上其它21点的牌类游戏，在你开启《21点狂人》时，更能以轻鬆、愉快、无负担的心情游玩，感受一玩就上瘾又无法自拔的轻博弈新体验。' ,   
            ' 《21點狂人》 以休閒娛樂為主體，並用簡單的介面、獨特玩法賠率、多人同場競賽等特點，結合21點簡單快節奏的特性，打造出以休閒娛樂型態為主的輕博弈類遊戲。相較於市面上其它21點的牌類遊戲，在你開啟《21點狂人》時，更能以輕鬆、愉快、無負擔的心情遊玩，感受一玩就上癮又無法自拔的輕博弈新體驗。' ,   
            ' 《21點狂人》 以休閒娛樂為主體，並用簡單的介面、獨特玩法賠率、多人同場競賽等特點，結合21點簡單快節奏的特性，打造出以休閒娛樂型態為主的輕博弈類遊戲。相較於市面上其它21點的牌類遊戲，在你開啟《21點狂人》時，更能以輕鬆、愉快、無負擔的心情遊玩，感受一玩就上癮又無法自拔的輕博弈新體驗。' ,
            ],
        appleURL:'',
        googleURL:'https://play.google.com/store/apps/details?id=com.lavapot.bjm',
        downloads:'500k+',
        imgURL:'../../static/img/games/bjm_icon.jpg'
    },
}


export {
    index,
    games
}